import React, { useEffect  } from "react";
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { connect } from "react-redux";
import { Grid} from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import UserItem from "../components/UserItem";
import { loadUserList, addNewUser, loadUserPermissionsList, updateUserPermissions, updateUserRole, loadRoleList } from "../api/userapi";
import LoaderComponent from "../components/LoaderComponent";
import SearchBoxComponent from "../components/SearchBoxComponent";
import { getUserList,  getUserLoading, getUserDialogStatus, getRolesList, getPermissions } from "../selector/selectors";
import PermissionModal from "../components/PermissionModal";
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { getUserPermissionRolesData } from "../api/userpermissionsapi";
import { loadPermissionsList } from "../api/permissionsapi";


function ManageUsers({
  isLoading,
  userList,
  startLoadingUsers,
  //addNewUser,
  startLoadingRole,
  roleList,
  //userDialogBoxStatus,
  permissionList,
  startLoadingPermissions
}) {
    
    const dispatch = useDispatch();
    let userType = 1;
    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchValue, setSearchValue] = React.useState('');
    const [openPermissionModal, setOpenPermissionModal]     = React.useState(false);
    const [updatedPermissionList, setUpdatedPermissionList] = React.useState([]);
    const [updatedUserList, setupdatedUserList] = React.useState([]);
    const [selectedUserId, setSelectedUserId]   = React.useState('');
    const [updatedRoleList, setUpdatedRoleList]        = React.useState([]);
    const userPermissionsList   =  useSelector((state) => state.userData.userPermissionsData);
    const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);
    
    useEffect(() => {
      startLoadingUsers(userType,'');
      startLoadingRole();
      startLoadingPermissions();
    }, [startLoadingRole,startLoadingUsers,userType,startLoadingPermissions]);

    useEffect(() =>{
      setupdatedUserList(userList?.data);
      let roleUpdateList = roleList?.data?.filter(val => val.role_type === '1');
      setUpdatedRoleList(roleUpdateList);
    },[userList,roleList])


    const handleChange = (event, newValue) => {
      setValue(newValue);
    };


    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingUsers(userType,searchValue,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingUsers(userType,searchValue,0,event.target.value);
    }

    const handleSearchUser = (event) => {
      setSearchValue(event.target.value);
      startLoadingUsers(userType,event.target.value);
    };

    const handlePermissionDialogOpen = (id) => {
      setOpenPermissionModal(true);
      setSelectedUserId(id);
      dispatch(loadUserPermissionsList(id));
    }

    const handlePermissionDialogClose = () => {
      setOpenPermissionModal(false);
      setSelectedUserId('');
    };

    useEffect(() => {
      const data = permissionList?.data?.map(permission => {
        let checkedVal = false;
        userPermissionsList?.data?.filter(userPermission => userPermission.permission_id === permission.id.toString() ?  checkedVal = true  : checkedVal);
        if(checkedVal){
          return {...permission,checked:true}
        } else {
          return {...permission,checked:false}
        } 
      });
      setUpdatedPermissionList(data);
    },[permissionList,userPermissionsList]);

    const handleSwitchChange = (id) => (event) =>{
      const updatedData = updatedPermissionList?.map(permission => {
        if(permission.id === id){
          return {...permission,checked:event.target.checked}
        }
        return permission;
      });
      setUpdatedPermissionList(updatedData);
    };

    const handleSaveData = () => {
      let permissions = updatedPermissionList;
      dispatch(updateUserPermissions(selectedUserId,permissions));
      setOpenPermissionModal(false);
      setTimeout (() => {
        dispatch(getUserPermissionRolesData());
      }, 1000);
    }

    const handleRoleChange = (event,userId) => {
      dispatch(updateUserRole(event.target.value,userId,userType,page));
      const newUserList = updatedUserList?.records?.map(item => (item.id === userId  ? { ...item,roleId:event.target.value} : item));
      setupdatedUserList({...updatedUserList,records:newUserList});
    }
  
    return (
      <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
        <Grid container >
         <TabContext value={value}>
            <Grid item xs={12} md={12} lg={12} >
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="">
                  {list?.data?.userDetails?.role_id === 1 &&
                    <Link className="tabingLinks" to="/web/roles">Roles</Link>
                  }
                  <Tab label="Users" value="1" />
                  {/* <Link className="tabingLinks" to="/web/app/users">SiteTech users</Link> */}
                  {list?.data?.userDetails?.role_id === 1 &&
                    <>
                    <Link className="tabingLinks" to="/web/permissions">Access Control</Link>
                    {/* <Link className="tabingLinks" to="/web/controller-permissions">Controller Access Control</Link> */}
                    </>
                  }
                </TabList>
              </Box>
              <Box sx={{paddingTop:'16px', borderBottom: 1, borderColor: 'divider' }}>
                <TabList aria-label="">
                  {list?.data?.userDetails?.role_id === 1 &&
                    <Tab label="Rehlink Sphere Users" value="1" />
                  }
                  <Link className="tabingLinks" to="/web/app/users">Rehlink users</Link>
                </TabList>
              </Box>
              <TabPanel value="1" sx={{p:0,pt:2}}>
                <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'space-between'}}>
                  <Grid xs={5} sm={6} md={3}>
                    <SearchBoxComponent
                      handleChangeTextValue = {(e)=>handleSearchUser(e,'')}
                      label='Search Email / Name'
                    />   
                  </Grid>
                </Grid>
                {/* <AddUserForm fields={fields} changeHandler={changeHandler} adminRolesList={updatedRoleList} handleFormData={handleFormData} handleDeleteInput={handleDeleteInput} /> */}
                <UserItem 
                  roleList={updatedRoleList} 
                  handlePermissionDialogOpen={handlePermissionDialogOpen} 
                  users={updatedUserList} 
                  page={page} 
                  rowsPerPage={rowsPerPage} 
                  handleChangeRowsPerPage={handleChangeRowsPerPage} 
                  handleChangePage={handleChangePage} 
                  handleRoleChange={handleRoleChange}
                  userType={userType}
                />
              </TabPanel>
            </Grid>
          </TabContext>
          <PermissionModal
              updatedPermissionList={updatedPermissionList}
              open={openPermissionModal}
              handlePermissionDialogClose={handlePermissionDialogClose}
              handleSaveData={handleSaveData}
              handleSwitchChange={handleSwitchChange}
          />
        </Grid>
      </Box>
    );
}
const mapStateToProps = (state) => ({
  isLoading             :   getUserLoading(state),  
  userList              :   getUserList(state), 
  userDialogBoxStatus   :   getUserDialogStatus(state), 
  roleList              :   getRolesList(state), 
  permissionList        :   getPermissions(state), 
});

const mapDispatchToProps = (dispatch) => ({
  addNewUser:(data,userType,page)  => dispatch(addNewUser(data,userType,page)),
  startLoadingRole:()              => dispatch(loadRoleList()),
  startLoadingUsers:(userType,searchText, page,rowsPerPage) => dispatch(loadUserList(userType,searchText, page,rowsPerPage)),
  startLoadingPermissions: ()      => dispatch(loadPermissionsList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);

